import { Link } from 'react-router-dom';
import SEO, { restaurantJsonLd } from '../components/SEO';
import { PAGE_SEO } from '../config/seo';
import { heroImages, menuPhotos } from '../assets/menuImages';
import { heroBackgroundStyle } from '../utils/imageAssets';
import HeroAnimatedTitle from '../components/HeroAnimatedTitle';
import HeroWomanShowcase from '../components/HeroWomanShowcase';
import NaturalJuicesSection from '../components/NaturalJuicesSection';
import PacksSection from '../components/PacksSection';
import OptimizedImage from '../components/OptimizedImage';
import {
  UtensilsIcon,
  ScooterIcon,
  LeafIcon,
  ChefHatIcon,
  ClockIcon,
  HeartIcon,
} from '../components/Icons';

const features = [
  { icon: LeafIcon, title: 'Ingrédients frais', desc: 'Sélectionnés chaque jour' },
  { icon: ChefHatIcon, title: 'Fait maison', desc: 'Recettes authentiques' },
  { icon: ClockIcon, title: 'Service rapide', desc: 'Prêt en quelques minutes' },
  { icon: HeartIcon, title: 'Fait avec passion', desc: 'Avec amour et expertise' },
];

const menuCategories = [
  { title: 'Burgers', desc: 'Savoureux & généreux', image: menuPhotos.burgers, link: '/menu' },
  { title: 'Tacos', desc: 'Généreux & épicés', image: menuPhotos.tacos, link: '/menu' },
  { title: 'Crêpes', desc: 'Sucrées ou salées', image: menuPhotos.crepes, link: '/menu' },
  { title: 'Boissons', desc: 'Jus naturels frais', image: menuPhotos.boissonsAccueil, link: '/menu?category=boissons' },
];

function Home() {
  return (
    <div className="home">
      <SEO {...PAGE_SEO.home} jsonLd={restaurantJsonLd()} />
      <div className="home-showcase">
        <section className="hero" style={heroBackgroundStyle(heroImages.background)}>
          <div className="hero-inner">
            <div className="hero-content">
              <HeroAnimatedTitle />
              <p className="hero-subtitle">
                Burgers, Crêpes, Tacos et plus encore… Préparés avec des ingrédients
                frais pour vous régaler à chaque moment.
              </p>
              <div className="hero-actions">
                <Link to="/menu" className="btn btn-primary">
                  <UtensilsIcon size={17} />
                  Découvrir le menu
                </Link>
                <Link to="/menu" className="btn btn-outline-white">
                  <ScooterIcon size={17} />
                  Commander en ligne
                </Link>
              </div>
            </div>
          </div>

          <div className="hero-visual-layer" aria-hidden="true">
            <div className="hero-sparkles">
              <span className="sparkle sparkle-1">✦</span>
              <span className="sparkle sparkle-2">✦</span>
            </div>
            <HeroWomanShowcase width={460} height={460} />
            <OptimizedImage
              image={heroImages.emblem}
              alt="DoWhile Food — Burgers, crêpes, tacos et plus"
              className="hero-logo-emblem"
              width={360}
              height={360}
            />
          </div>
        </section>

        <section className="features-bar">
          <div className="features-inner">
            {features.map(({ icon: Icon, title, desc }) => (
              <div key={title} className="feature-item">
                <div className="feature-icon">
                  <Icon size={16} />
                </div>
                <div>
                  <p className="feature-title">{title}</p>
                  <p className="feature-desc">{desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>

      <section className="menu-section">
        <div className="menu-section-inner">
          <div className="section-heading">
            <h2 className="section-title">Notre menu</h2>
            <p className="section-subtitle">
              Découvrez nos spécialités préparées avec amour
            </p>
          </div>

          <div className="menu-grid">
            {menuCategories.map(({ title, desc, image, link }) => (
              <article key={title} className="menu-card">
                <div className="menu-card-image">
                  <OptimizedImage image={image} alt={title} loading="lazy" />
                </div>
                <div className="menu-card-body">
                  <h3 className="menu-card-title">{title}</h3>
                  <p className="menu-card-desc">{desc}</p>
                  <Link to={link} className="btn-discover">
                    Découvrir
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <PacksSection />

      <NaturalJuicesSection />
    </div>
  );
}

export default Home;
